import React, { useState } from 'react';

import isEmpty from 'lodash/isEmpty';
import isPlainObject from 'lodash/isPlainObject';
import isString from 'lodash/isString';

import {
  Typography,
  ConfirmDialog,
  UploadFile,
  Grid,
  InsertDriveFileOutlinedIcon,
  MultiSelect,
  HTMLRichText,
} from '@gogame/components';

import IOTitle from 'scenes/IO/components/IOTitle';
import { useLoadReasons } from 'scenes/IO/data/useLoadReasons';
import { loadUsersSuggestions } from 'scenes/IO/sources/businessEntities';
import { uploadFile } from 'scenes/IO/sources/upload';

const FILE_TYPES = {
  1: 'Agreement',
  2: 'Frame Agreement',
  3: 'IO',
  4: 'Agreement With Io',
};

const ConfirmationDialog = ({
  io = {},
  withUpload,
  withReason,
  withTextField,
  textFieldRequired,
  ...props
}) => {
  const [attaches, setAttaches] = useState([]);
  const [reasons, setReasons] = useState([]);
  const [comment, setComment] = useState('');
  const [error, setReasonsError] = useState(null);

  const { data = [], isLoading } = useLoadReasons();

  const handleImport = (value) => async (_e, files) => {
    const response = await uploadFile(files[0]);
    const result = [...attaches];
    const filtered = result.filter((el) => el.type !== value);

    setAttaches([...filtered, { ...response, type: value }]);
  };

  const handleSubmit = () => {
    if (withReason && isEmpty(reasons)) {
      setReasonsError('Please choose reason');
      return;
    }
    if (textFieldRequired && isEmpty(comment)) {
      setReasonsError('Please input comment');
      return;
    }
    props.onSubmit({
      ...(!isEmpty(comment) && {
        comment,
      }),
      ...(!isEmpty(attaches) && {
        attaches,
      }),

      ...(!isEmpty(reasons) && {
        reasons,
      }),
    });
  };

  const handleReasonChange = (_e, value) => {
    if (error && !isEmpty(value)) {
      setReasonsError(null);
    }
    setReasons(value);
  };

  const getFileName = (value) => {
    const file = attaches.find((file) => file.type === value);

    return file ? file.name : '';
  };

  const handleChangeComment = (_, v) => setComment(v);

  return (
    <ConfirmDialog {...props} onSubmit={handleSubmit}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography>
            <IOTitle businessPartner={io.businessPartner} period={io.period} />{' '}
            {io.createdBy && isPlainObject(io.createdBy)
              ? 'by ' + io.createdBy.name
              : ''}
            {io.createdBy && isString(io.createdBy) ? 'by ' + io.createdBy : ''}
          </Typography>
        </Grid>
        {withReason && (
          <Grid item xs={12}>
            <MultiSelect
              loading={isLoading}
              options={data}
              label={'Reason'}
              value={reasons}
              onChange={handleReasonChange}
              required={true}
              error={error}
            />
          </Grid>
        )}
        {withUpload &&
          io?.attachments?.length &&
          io.attachments.map((attachment) => {
            return (
              <Grid item xs={12}>
                <UploadFile
                  icon={<InsertDriveFileOutlinedIcon />}
                  label={`Replace ${FILE_TYPES[attachment.value]}`}
                  onUpload={handleImport(attachment.value)}
                  helper={getFileName(attachment.value)}
                  accept={'.pdf, .docx'}
                  direction={'column'}
                  multiple={false}
                />
              </Grid>
            );
          })}
        {withTextField ? (
          <Grid item xs={12}>
            <HTMLRichText
              value={comment}
              onChange={handleChangeComment}
              label={`Comment${textFieldRequired ? '*' : ' (optional)'}`}
              padding={0}
              autofocus={true}
              loadMentions={loadUsersSuggestions}
            />
          </Grid>
        ) : null}
      </Grid>
    </ConfirmDialog>
  );
};

export default ConfirmationDialog;
